import statsRepository from '@/domain/repository/StatsRepository';

import {Stats} from '@/domain/entities/Stats';

export const getStatsForProject = async (projectUuid: string): Promise<Stats | undefined> => {
  try {
    return statsRepository.getStats(projectUuid);
  } catch (error) {
    console.error('Error fetching stats', error);
    return undefined;
  }
};